// MST
import { types, flow } from 'mobx-state-tree'

// Interfaces
import { IOtpApiGetResponse, IOtpApiValidateResponse } from 'interfaces/back-office/otp/otp-api.interface'
import { IOtpGetAttrs, IOtpValidateAttrs } from 'interfaces/back-office/otp/otp-view.interface'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'

const OtpStoreModel = types
  .model('Otp')
  .props({
    otp_isLoading: types.optional(types.boolean, false),
    otp_isValidateLoading: types.optional(types.boolean, false),
  })
  .extend(withEnvironment)
  .actions(self => ({
    otp_SET_LOADING: (payload: boolean): void => {
      self.otp_isLoading = payload
    },
    otp_SET_VALIDATE_LOADING: (payload: boolean): void => {
      self.otp_isValidateLoading = payload
    },
  }))
  .actions(self => ({
    /**
     * @description Get OTP
     *
     * @param {IOtpGetAttrs} payload
     *
     * @return {any} any
     */
    otp_get: flow(function* (payload: IOtpGetAttrs) {
      self.otp_SET_LOADING(true)

      const response: IOtpApiGetResponse = yield self.environment.otpApi.otp_get({
        body: { ...payload.body, phoneNo: `62${payload.body.phoneNo}` },
        requestConfig: { ...payload.requestConfig },
      })

      if (response.ok) {
        // Do when response success
        if (payload?.onSuccess) payload.onSuccess(response.res.data)
      }

      if (!response.ok) {
        // Do when response failed
        if (payload?.onError) payload.onError()
      }

      self.otp_SET_LOADING(false)
    }),

    /**
     * @description Validate OTP
     *
     * @param {IOtpValidateAttrs} payload
     *
     * @return {any} any
     */
    otp_validate: flow(function* (payload: IOtpValidateAttrs) {
      self.otp_SET_VALIDATE_LOADING(true)

      const response: IOtpApiValidateResponse = yield self.environment.otpApi.otp_validate({
        body: { ...payload.body },
        requestConfig: { ...payload.requestConfig },
      })

      if (response.ok) {
        // Do when response success
        if (payload?.onSuccess) payload.onSuccess(response.res.data.validated)
      }

      if (!response.ok) {
        // Do when response failed
        if (payload?.onError) payload.onError()
      }

      self.otp_SET_VALIDATE_LOADING(false)
    }),
  }))

export const createOtpStoreDefaultModel = () => types.optional(OtpStoreModel, {})
